<template>
	<div>
		<v-form ref="form" class="mx-2" lazy-validation>
			<v-card class="px-3 py-5 mb-3" style="background-color: #f1f1f1;">
				<v-row>
					<v-col cols="12" class="py-0">
						<v-text-field :disabled="true" v-model="localData.apiKey" label="کلید رابط" :error-messages="errorMessages" :rules="[(val) => !!val || 'کلید رابط را وارد کنید', () => !localData.apiKey || localData.apiKey.length >= 20 || 'طول کاراکتر های کلید معتبر نمی باشد.']" required />
					</v-col>
					<v-col cols="12" class="py-0 text-left">
						<v-btn @click="generateKey()" small>
							تولید کلید جدید
						</v-btn>
					</v-col>

					<v-col cols="12" class="py-0">
						<v-text-field v-model="localData.apiPassword" label="کلمه عبور" :error-messages="errorMessages" :rules="[(val) => !!val || 'کلید رابط را وارد کنید']" required />
					</v-col>

				</v-row>
			</v-card>
		</v-form>
		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" :loading="loading" dark @click="submit()">
				ذخیره
			</v-btn>
		</v-card-actions>
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import _ from 'lodash'
	import router from '@/router'

	export default {
		name: 'ApiSettingsView',
		props: {
			data: { type: Object },
		},
		data() {
			return {
				errorMessages: '',
				localData: { dashboardSettings: {}, iceConfig: {}, iranValidityConfig: {}, finnoTechConfig: {} },
				loading: false
			}
		},
		mounted() {
			this.prepareData()
		},
		computed: {
			...get('siteConfig', [
				'isCloud'
			]),
			...get('auth', [
				'getCurrentUser'
			])
		},
		methods: {
			...call('appSettings/*'),
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.loading = true
				var data = _.cloneDeep(this.localData)
				this.sync(data).then(x => {
					this.loading = false
					toast.success('اطلاعات با موفقیت ذخیره شد.')
					this.$emit('callbck', false)
				}).catch(err => {
					this.loading = false
					toast.error(err.message)
				})
			},
			prepareData() {
				this.fetch({ force: true }).then(x => {
					this.localData = x
				})
			},
			generateKey() {
				let key = ''
				for (let i = 0; i < 3; i++) {
					key += (Math.random() + 1).toString(36).substring(2)
				}
				this.localData.apiKey = key
			}
		},
	}
</script>
<style scoped>
	.sms-row {
		justify-content: center;
		align-items: center;
		border-bottom: 1px solid #d7d7d7;
	}
</style>
